export enum HomeHealthFrequencyWatchEnableAgenciesEnum {
    // HomeHealth Test agency
    HomeHealth = "14c5e22f-3f32-44d4-8e6c-894b3e79a418",

    // Enterprise Sales Demo
    EnterpriseSalesDemo = "05e30f68-80ea-4ac8-9ef7-9cb18c9a1df6"
}
